module.exports = __webpack_public_path__ + "static/media/logo-white.a4f88184.png";